import { v4 as uuidv4 } from 'uuid';

import { ProductsSequenceProduct } from 'common/contracts';
import { EProductPriority } from 'constants/enums';

import { MAX_PRODUCTS_PER_SEQUENCE } from './usePopupProducts.consts';
import { ProductEntry } from './usePopupProducts';

export const appendProduct = (
  list: ProductEntry[],
  product: ProductsSequenceProduct,
): ProductEntry[] => {
  if (list.length >= MAX_PRODUCTS_PER_SEQUENCE) return list;
  return [...list, { ...product, id: uuidv4() }];
};

export const replaceWithSingleProduct = (
  product: ProductsSequenceProduct,
): ProductEntry[] => [{ ...product, id: uuidv4() }];

export const seedSingleFromMulti = (
  list: ProductEntry[],
): ProductEntry[] => {
  if (list.length === 0) return [];
  const main = list.find((p) => p.priority === EProductPriority.MAIN);
  return [main ?? list[0]];
};
